/**
 * 地块绘制工具
 */
import Base from "./Base";
import MapCommon from "../../common/MapCommon";
import _ from "lodash"
import {TOOL_SELECT} from "./ToolType";
import {TEMP_LAYER_NAME_SELECT,TEMP_LAYER_NAME_SELECT_SUFFIX} from "./Constants";


export default class SelectPolygon extends Base {
  /**
   *
   */
  constructor(options) {
    let params={
      map:null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-tianjia",//图标类名
      callBackName: "",//正常地图事件回调
      errorEventName: "",//错误地图事件回调
      chineseName: "点选",//中文工具名称
      continueSelect:true,//是否连续添加
      callBack:null,
      errorCallBack:null,
      clickLayers:[],//点选目标图层id
      features:[],//需要展示到点选图层的要素
      clickLayersFilters:[],//点击图层过滤器
      stopLayers:[],//遮挡图层id
      innerUse:false,
    }
    Object.assign(params,options)


    super(params.map,TOOL_SELECT,params);


    //已选择要素集
    this.mode = params.continueSelect;//多选模式
    this.clickLayersFilters=params.clickLayersFilters;
    this.stopLayers=params.stopLayers;

    this.params=params;
  }

  /**
   * 添加需要添加的图测定
   */
  initClickLayer(){
    let params=this.params;
    this.clickLayers=[];//点击查询的图层

    if(params.stopLayers){
      params.clickLayers=params.clickLayers.concat(params.stopLayers)
    }
    for (let i = 0; i <params.clickLayers.length ; i++) {
      MapCommon.copyLineToAreaFit(this.map,params.clickLayers[i],params.clickLayers[i]+TEMP_LAYER_NAME_SELECT_SUFFIX);
      this.clickLayers.push(params.clickLayers[i]+TEMP_LAYER_NAME_SELECT_SUFFIX);
    }
    //初始化已选择要素
    this.selectSet={
      "type": "FeatureCollection",
      "features": params.features||[]
    };
  }


  start() {
    super.start();

    //将所有点击线图层转化为面图层
    this.initClickLayer();
    //增加高亮图层
    if (!this.map.getSource(TEMP_LAYER_NAME_SELECT)) {
      this.map.addSource(TEMP_LAYER_NAME_SELECT, {
        "type": "geojson",
        "data": this.selectSet
      });
    }
    //添加选择集图层
    if (!this.map.getLayer(TEMP_LAYER_NAME_SELECT)) {
      this.map.addLayer({
        id: TEMP_LAYER_NAME_SELECT,
        source: TEMP_LAYER_NAME_SELECT,
        "minzoom": 7,
        "maxzoom": 18,
        type: 'line',
        "paint": {
          "line-color": "#fffe21",
          "line-opacity": 1,
          "line-width": 6
        },
      });
    }
    this.clickEvent=(e)=>{
      this.select([e.originalEvent.layerX, e.originalEvent.layerY])
    }

    //添加点击事件
    this.map.on('click', this.clickEvent);
  }

  /**
   * 通过点查询用户点击的面要素
   * @param point
   */
  select(point){
    if(this.clickLayers.length===0){
      return;
    }
    let renderFeatures = this.map.queryRenderedFeatures(point, {layers: this.clickLayers});
    if(!renderFeatures||renderFeatures.length===0){
      return;
    }

    //确定优先选中的要素
    let priorityRenderF = this.getPriorityRenderFeature(renderFeatures);
    if(!priorityRenderF||priorityRenderF.length===0){
      return;
    }
    // console.log("选择地块测试")
    // console.log(renderFeatures)
    // console.log(priorityRenderF)
    //避免地块被切片分割的问题
    // let source=this.map.getSource(priorityRenderF.sourceLayer)
    // if(source.type!=="geojson"){}
    let features = this.map.querySourceFeatures(priorityRenderF.layer.source, {'sourceLayer': priorityRenderF.sourceLayer, 'filter': ['==', 'objectid', priorityRenderF.properties.objectid]});
    let temp = MapCommon.unionFeatures(features);
    temp.properties=priorityRenderF.properties;
    temp.source=priorityRenderF.source;
    temp.sourceLayer=priorityRenderF.sourceLayer;
    temp.layer=priorityRenderF.layer;

    priorityRenderF=temp;
    priorityRenderF.properties.myobjectid=priorityRenderF.source+priorityRenderF.properties.objectid;
    // 判断正选反选
    let anti_index = this.isAnti_Election(priorityRenderF);
    if(anti_index < 0 && this.selectSet.features && this.selectSet.features.length>=20){
      alert('最多可选择20个地块！');
      return
    }

    this.update(priorityRenderF, anti_index);

  }

  //更新source
  update(feature, anti_index) {
    //反选
    if (anti_index > -1) {
      //选中后,再取消走这
      this.selectSet.features = _.filter(this.selectSet.features, (o) => {
        return o.properties.myobjectid !== feature.properties.myobjectid
      })
    }
    //非反选
    if (anti_index < 0) {
      // 头一次选中-->走这
      this.mode ? this.selectSet.features.push(feature) : this.selectSet.features = [feature]
    }
    if (this.map.getSource('selectionSetDraw')) {
      //  不管第几次选,都会走这
      this.map.getSource('selectionSetDraw').setData(this.selectSet);
    }
    this.finish(this.selectSet)
    //非联系选择，关闭后续选择
    if(!this.mode){
      this.inActiveIcon();
    }
  }

  //-1非反选; >-1反选
  isAnti_Election(sourceF) {
    if (!sourceF) {
      return
    }
    let myobjectid = sourceF.properties['myobjectid'];
    let index = _.findIndex(this.selectSet.features, (feature) => {
      return feature.properties.myobjectid === myobjectid
    })
    return index
  }


  //获取优先级高的图层要素
  getPriorityRenderFeature(features) {
    let priority = null;
    //特定图层阻挡下层点击事件
    for (let i = 0; i < this.stopLayers.length; i++) {
      for (let j = 0; j <features.length ; j++) {
        if(this.stopLayers[i]+TEMP_LAYER_NAME_SELECT_SUFFIX==features[j].layer.id){
          return null;
        }
      }
    }
    for (let i = 0; i < this.clickLayers.length; i++) {
      let index = _.findIndex(features, (renderF) => {
        if(renderF.layer.id === this.clickLayers[i]){
          let filters=this.clickLayersFilters.filter(item=>
            (item.layer+TEMP_LAYER_NAME_SELECT_SUFFIX)===renderF.layer.id
          );
          if(filters.length===0){
            return true;
          }

          let filter=filters[0];

          if(renderF.properties&&renderF.properties[filter.key]&&renderF.properties[filter.key]==filter.value){
            return false
          }else {
            return true;
          }
        }else {
          return false;
        }
      });

      if (index > -1) {
        priority = JSON.parse(JSON.stringify(features[index]));
        break
      }
    }
    return priority
  }



  close(notClearMap=false) {
    this.clear(notClearMap);
    this.clearEvent();
  }

  clear(notClearMap=false) {
    this.clearMap(notClearMap);
  }

  clearMap(notClearMap=false) {
    //不清除地图选择绘制图层
    if(!notClearMap){
      super.clearMap();
    }

    for (let i = 0; i <this.clickLayers.length ; i++) {
      if (this.map.getLayer(this.clickLayers[i])) {
        this.map.removeLayer(this.clickLayers[i]);
      }
    }

  }

  clearEvent() {
    super.clearEvent();
    this.map.off('click',this.clickEvent);
    this.selectSet={
      "type": "FeatureCollection",
      "features": [
      ]
    };
    this.clickLayers=[];
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/SelectPolygon.js